import config from 'config';
import * as firebase from 'firebase/app';
import 'firebase/messaging';

const fcmConfig = {
  apiKey: config.fcmApiKey,
  authDomain: config.authDomain,
  databaseURL: config.dbUrl,
  projectId: config.projectId,
  storageBucket: config.storageBucket,
  messagingSenderId: config.senderId,
  appId: config.appId,
};

export const initializeFirebase = async () => {
  if (!firebase.apps[0]) {
    firebase.initializeApp(fcmConfig);
    await askForPermissionToReceiveNotifications();
  }
};

export const askForPermissionToReceiveNotifications = async () => {
  let messaging = null;
  if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging();
    try {
      await messaging.requestPermission();
      const token = await messaging.getToken();
      window.sessionStorage.setItem('fcm_token', token);
      return token;
    } catch (error) {
      console.error(error);
      return null;
    }
  }

  return null;
};
